import Immutable from 'immutable';
export var loadState = function () {
    try {
        var serializedState = localStorage.getItem('betSlips');
        if (serializedState === null) {
            return undefined;
        }
        var betSlips = Immutable.fromJS(JSON.parse(serializedState));
        return betSlips.mapKeys(function (key) { return parseInt(key); });
    }
    catch (err) {
        console.warn(err);
        return undefined;
    }
};
export var saveState = function (state) {
    try {
        var serializedState = JSON.stringify(state.betSlips);
        localStorage.setItem('betSlips', serializedState);
    }
    catch (err) {
        console.warn(err);
        //Ignore write erros;
    }
};



// WEBPACK FOOTER //
// ./src/storage.js